module.exports = __webpack_public_path__ + "img/kuaidi.c375b842.png";